import React from 'react';
import { Stepper } from '@domain-group/fe-co-form-elements';
import * as styles from './feature-stepper.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FeatureStepper = _ref => {
  var name = _ref.name,
    Icon = _ref.icon,
    value = _ref.value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? () => {} : _ref$onChange;
  var handleChange = event => {
    onChange(Number.parseInt(event.target.value, 10) || 0);
  };
  return ___EmotionJSX("div", {
    css: styles.featureStepper
  }, ___EmotionJSX("label", {
    css: styles.label,
    htmlFor: "feature-".concat(name)
  }, ___EmotionJSX(Icon, {
    css: styles.icon,
    size: "custom"
  }), " ", name), ___EmotionJSX(Stepper, {
    onChange: handleChange,
    id: "feature-".concat(name),
    value: "".concat(value),
    appearance: "thin"
  }));
};
export default FeatureStepper;